module.exports = __webpack_public_path__ + "img/facebook_logo.64c55802.svg";